var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.927 13.202L8.481 2.26C8.42897 2.17989 8.35768 2.11411 8.27364 2.06868C8.18961 2.02326 8.09552 1.99964 8 2C7.90447 1.99964 7.81039 2.02326 7.72635 2.06868C7.64232 2.11411 7.57103 2.17989 7.519 2.26L1.073 13.202C1.0249 13.2834 0.999785 13.3764 1.00031 13.4709C1.00084 13.5655 1.027 13.6581 1.076 13.739C1.176 13.904 1.358 14.004 1.554 13.999H14.446C14.5415 14.0013 14.6359 13.9786 14.7198 13.9329C14.8037 13.8873 14.8741 13.8204 14.924 13.739C15.024 13.574 15.025 13.369 14.927 13.202ZM8.875 12.285H7.125V10.57H8.875V12.285ZM8.875 9.712H7.125V5.425H8.875V9.712Z",
    fill: "#E12E2E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.7de43b55e693577a162413357e85a08c.svg";
export { ForwardRef as ReactComponent };